'use client';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Flex,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
   Checkbox,
   Drawer,
   DrawerOverlay,
   DrawerContent,
   DrawerCloseButton,
   DrawerHeader,
   DrawerBody,
   useOutsideClick,
   Spinner,
   useColorMode,
} from '@chakra-ui/react';
import Select from 'react-select';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem, Input } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import {
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   Image,
   Thead,
   Th,
   Grid,
   IconButton,
} from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { getProfitLossMonthly } from '../../../../redux/actions/reports';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import { SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { renderDynamicDropdown } from '../../../../components/ui/DynamicDropdown';
import { jsPDF } from 'jspdf';
// import * as XLSX from 'xlsx';
import { motion } from 'framer-motion';
import { LuRefreshCcw } from 'react-icons/lu';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import * as XLSX from 'xlsx-js-style';
import { useGlobal, useUser } from 'contexts';
import AccountingReportsFilter from '../components/AccountingReportsFilter';
import { IoFilterOutline } from 'react-icons/io5';
import Loader from 'views/admin/default/Loader';
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const ProfitLossMonthly = () => {
   const columnHelper = createColumnHelper();
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const company = useSelector((state) => state.company.list || []);
   // const [fromDate, setFromDate] = useState(null);
   // const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   const accounts = useSelector((state) => state.account.list || []);
   const [companyFilter, setCompanyFilter] = useState([]);
   const [reportType, setReportType] = useState('Profit & Loss Monthly');
   const [expandedItems, setExpandedItems] = useState({});
   const [sorting, setSorting] = useState([]);
   const [columnVisibility, setColumnVisibility] = useState({});
   const [isColumnSelectorOpen, setIsColumnSelectorOpen] = useState(false);
   const { user } = useUser();
   const dbName = company?.dbName;
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const companyBg = useColorModeValue('#F1F0E8', '#16213E');
   const searchTimeoutRef = useRef(null);
   const [isLoading, setIsLoading] = useState(false);
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const isFirstRenderFilter = useRef(true);
   const [stockInput, setStockInput] = useState('');
   const ProfitLossMonthly = useSelector((state) => state.reports?.ProfitLossMonthly || []);
   const { userGlobalSettingsData } = useGlobal();
   const globalSettingAcc = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdownAcc = globalSettingAcc || false;
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
         toDate: today.toISOString().split('T')[0], // today
      };
   });
   const reportTypeOptions = [
      { value: 'Profit & Loss Monthly', label: 'Profit & Loss Monthly' },
      { value: 'Profit & Loss T Format', label: 'Profit & Loss T Format' },
      { value: 'Profit & Loss Vertical', label: 'Profit & Loss Vertical' },
   ];

   const handleCompanyChange = (selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   };

   const dispatch = useDispatch();
   const fromDateInputRef = useRef(null);

   // Initialize column visibility for Balance Sheet columns
   useEffect(() => {
      const initialColumnVisibility = {
         accountName: true,
         debit: true,
         credit: true,
      };
      setColumnVisibility(initialColumnVisibility);
   }, []);

   useEffect(() => {
      if (isFirstRenderFilter.current) {
         isFirstRenderFilter.current = false;
         return;
      }
      setIsFilterLoading(false);
   }, [ProfitLossMonthly]);

   const columns = useMemo(() => {
      return [];
   }, [columnHelper, textColor]);

   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [],
      [companyFilter],
   );

   const { isOpen, onOpen, onClose } = useDisclosure();
   const [datePartyWiseSalesRange, setPartyWiseSalesDateRange] = useState('');

   const table = useReactTable({
      data: ProfitLossMonthly,
      columns,
      state: {
         sorting,
         columnVisibility,
      },
      onSortingChange: setSorting,
      onColumnVisibilityChange: setColumnVisibility,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const [fromDate, setFromDate] = useState(() => {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 1);
      return today.toISOString().split('T')[0];
   });
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);

   const { companyList } = useGlobal();

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   useEffect(() => {
      const fetchData = async () => {
         setIsLoading(true);

         // Get company IDs with validation
         const companyIds =
            companyFilter.length > 0
               ? companyFilter.filter((id) => !isNaN(Number(id)) && Number(id) > 0) // Filter out invalid IDs
               : localStorage.getItem('companyId') &&
                  !isNaN(Number(localStorage.getItem('companyId'))) &&
                  Number(localStorage.getItem('companyId')) > 0
                  ? [parseInt(localStorage.getItem('companyId'), 10)]
                  : [];

         // Validate all required parameters before making API call
         const hasValidCompanyIds =
            Array.isArray(companyIds) &&
            companyIds.length > 0 &&
            !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
         const hasValidDateRange = datePartyWiseSalesRange && fromDate && toDate;

         if (hasValidCompanyIds && hasValidDateRange) {
            try {
               if (reportType === 'Profit & Loss T Format') {
                  await dispatch(
                     getProfitLossMonthly({
                        companyIds: companyIds.join(','),
                        fromDate: datePartyWiseSalesRange.fromDate,
                        toDate: datePartyWiseSalesRange.toDate,
                        search: debouncedSearchQuery,
                        ...(stockInput !== '' && { balance: Number(stockInput) }),
                     }),
                  );
               } else if (reportType === 'Profit & Loss Monthly') {
                  await dispatch(
                     getProfitLossMonthly({
                        companyIds: companyIds.join(','),
                        fromDate: datePartyWiseSalesRange.fromDate,
                        toDate: datePartyWiseSalesRange.toDate,
                        search: debouncedSearchQuery,
                     }),
                  );
               } else {
                  await dispatch(
                     getProfitLossMonthly({
                        companyIds: companyIds.join(','),
                        fromDate: datePartyWiseSalesRange.fromDate,
                        toDate: datePartyWiseSalesRange.toDate,
                        search: debouncedSearchQuery,
                        ...(stockInput !== '' && { balance: Number(stockInput) }),
                     }),
                  );
               }
            } catch (error) {
               console.error('Error fetching data:', error);
            } finally {
               setIsLoading(false);
            }
         } else {
            // If conditions aren't met, still set loading to false
            setIsLoading(false);

            // Optional: Log why the API call was skipped
            if (!hasValidCompanyIds) {
               console.log('Skipping API call: Invalid or missing company IDs');
            }
            if (!hasValidDateRange) {
               console.log('Skipping API call: Invalid or missing date range');
            }
         }
      };

      fetchData();
   }, [dispatch, companyFilter, fromDate, toDate, reportType, debouncedSearchQuery, datePartyWiseSalesRange, stockInput]);

   const handleRefresh = async () => {
      setIsLoading(true);
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [];

      try {
         if (fromDate && toDate && companyIds.length > 0 && !companyIds.some(isNaN)) {
            if (reportType === 'Profit & Loss T Format') {
               await dispatch(
                  getProfitLossMonthly({
                     companyIds: companyIds.join(','),
                     fromDate: datePartyWiseSalesRange.fromDate,
                     toDate: datePartyWiseSalesRange.toDate,
                     search: debouncedSearchQuery,
                     ...(stockInput !== '' && { balance: Number(stockInput) }),
                  }),
               );
            } else if (reportType === 'Profit & Loss Monthly') {
               await dispatch(
                  getProfitLossMonthly({
                     companyIds: companyIds.join(','),
                     fromDate: datePartyWiseSalesRange.fromDate,
                     toDate: datePartyWiseSalesRange.toDate,
                     search: debouncedSearchQuery,
                  }),
               );
            } else {
               await dispatch(
                  getProfitLossMonthly({
                     companyIds: companyIds.join(','),
                     fromDate: datePartyWiseSalesRange.fromDate,
                     toDate: datePartyWiseSalesRange.toDate,
                     search: debouncedSearchQuery,
                     ...(stockInput !== '' && { balance: Number(stockInput) }),
                  }),
               );
            }
         }
      } catch (error) {
         console.error('Refresh error:', error);
      } finally {
         setIsLoading(false);
      }
   };

   const handleDateRangeChange = (dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));

      setPartyWiseSalesDateRange({ fromDate: from, toDate: to });
   };

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value); // Update UI immediately

      // Clear previous timeout
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }

      // Set new timeout (500ms after typing stops)
      searchTimeoutRef.current = setTimeout(() => {
         performSearch(value);
      }, 500);
   };

   useEffect(() => {
      const handler = setTimeout(() => {
         setDebouncedSearchQuery(searchQuery);
      }, 500);

      return () => {
         clearTimeout(handler);
      };
   }, [searchQuery]);

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   const performSearch = async (query) => {
      if (isLoading) return;

      setIsLoading(true);
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [];

      try {
         await dispatch(
            getProfitLossMonthly({
               companyIds: companyIds.join(','),
               fromDate: datePartyWiseSalesRange?.fromDate || fromDate,
               toDate: datePartyWiseSalesRange?.toDate || toDate,
               search: query,
            }),
         );
      } catch (error) {
         console.error('Search error:', error);
      } finally {
         setIsLoading(false);
      }
   };

   useEffect(() => {
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
      };
   }, []);

   const formatCurrency = useCallback((value) => {
      if (value === null || value === undefined || value === '') return '0.00';
      const num = Number(value);
      if (isNaN(num)) return '0.00';
      return num.toLocaleString('en-IN', {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });
   }, []);

   const lastcompanyOptions = useMemo(() => {
      const currentUserCode = user?.loginhistory?.code;
      const currentCompanyId = user?.loginhistory?.companyId;

      // SHARED COMPANY MODE: When code is present
      if (currentUserCode) {
         // Find the company with matching ID AND matching dbName
         const sharedCompany = companyList.find(
            company => company.id === currentCompanyId && company.dbName === currentUserCode
         );

         if (sharedCompany) {
            return [{
               value: sharedCompany.id,
               label: sharedCompany.name,
               id: sharedCompany.id,
               name: sharedCompany.name,
            }];
         }

         // Fallback: try to find by dbName only
         const companiesWithDbName = companyList.filter(company => company.dbName === currentUserCode);
         if (companiesWithDbName.length > 0) {
            return companiesWithDbName.map(company => ({
               value: company.id,
               label: company.name,
               id: company.id,
               name: company.name,
            }));
         }

         return [];
      }

      // NORMAL MODE: When no code, show companies without dbName
      return companyList
         .filter(company => !company.dbName)
         .map(company => ({
            value: company.id,
            label: company.name,
            id: company.id,
            name: company.name,
         }));
   }, [companyList, user?.loginhistory?.code, user?.loginhistory?.companyId]);

   const calculateGrandTotals = useCallback(() => {
      if (!ProfitLossMonthly || ProfitLossMonthly.length === 0 || companyFilter.length <= 1) {
         return null;
      }

      const grandTotals = {
         totalAmount: 0,
         totalDebit: 0,
         totalCredit: 0,
         totalBalance: 0,
         totalPaid: 0,
         categoryCount: 0,
         itemCount: 0,
         companyCount: companyFilter.length,
         monthlyTotals: {},
         companyNames: []
      };

      ProfitLossMonthly.forEach((companyData) => {
         if (companyData?.companyName) {
            grandTotals.companyNames.push(companyData.companyName);
         }

         if (companyData?.data && Array.isArray(companyData.data)) {
            companyData.data.forEach((group) => {
               // Count categories
               grandTotals.categoryCount++;

               if (group?.data && Array.isArray(group.data)) {
                  group.data.forEach((item) => {
                     // Count items
                     grandTotals.itemCount++;

                     // Sum amounts
                     const amount = Math.abs(Number(item.total) || 0);
                     grandTotals.totalAmount += amount;

                     // Track by type (debit/credit based on group type)
                     const isDebitSide = [
                        'EXPENSES',
                        'COST OF GOODS SOLD',
                        'OPERATING EXPENSES',
                        'PURCHASES',
                        'DIRECT EXPENSES',
                        'INDIRECT EXPENSES',
                        'PURCHASE',
                        'JOB CHARGE',
                        'PACKAGING EXPENSES',
                     ].some((type) => group.type?.toUpperCase().includes(type.toUpperCase()));

                     if (isDebitSide) {
                        grandTotals.totalDebit += amount;
                     } else {
                        grandTotals.totalCredit += amount;
                     }
                  });
               }

               // Handle monthly totals
               if (group?.monthData) {
                  Object.entries(group.monthData).forEach(([month, value]) => {
                     if (!grandTotals.monthlyTotals[month]) {
                        grandTotals.monthlyTotals[month] = 0;
                     }
                     grandTotals.monthlyTotals[month] += Math.abs(Number(value) || 0);
                  });
               }
            });
         }
      });

      // Calculate net profit/loss
      grandTotals.netProfitLoss = grandTotals.totalCredit - grandTotals.totalDebit;
      grandTotals.totalBalance = grandTotals.totalAmount;
      grandTotals.totalPaid = grandTotals.totalCredit; // Assuming paid = credit side

      return grandTotals;
   }, [ProfitLossMonthly, companyFilter]);

   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const GrandTotalHeader = React.memo(({ grandTotals, formatCurrency, reportType }) => {
      const companyBg = useColorModeValue('#F1F0E8', '#16213E');

      if (!grandTotals) return null;

      // Format months for display
      const months = Object.keys(grandTotals.monthlyTotals || {}).sort((a, b) => {
         const monthsOrder = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
         const monthA = a.split('-')[0];
         const monthB = b.split('-')[0];
         return monthsOrder.indexOf(monthA) - monthsOrder.indexOf(monthB);
      });

      const isProfitable = grandTotals.netProfitLoss > 0;

      return (
         <Box mb={6} className="animate-slideDown">
            {/* Main Grand Total Header */}
            <div
               className={`
               rounded-xl overflow-hidden shadow-2xl mb-4
               ${isDark
                     ? 'bg-gradient-to-r from-gray-800 via-gray-900 to-gray-800 border border-indigo-800'
                     : 'bg-gradient-to-r from-indigo-50 via-purple-50 to-pink-50 border border-indigo-200'
                  }
            `}>

               {/* Header Section */}
               <div className={`px-6 py-4 ${isDark ? 'bg-gray-800/50' : 'bg-white/50'} backdrop-blur-sm`}>
                  <div className="flex items-center justify-between flex-wrap gap-4">
                     <div className="flex items-center gap-4">
                        <div className={`
                        w-12 h-12 rounded-full flex items-center justify-center
                        ${isDark ? 'bg-indigo-900/50' : 'bg-indigo-100'}
                     `}>
                           <span className="text-2xl">📊</span>
                        </div>
                        <div>
                           <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>
                              CONSOLIDATED GRAND TOTAL
                           </h2>
                           <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                              {grandTotals.companyCount} Companies • {grandTotals.categoryCount} Categories • {grandTotals.itemCount} Items
                           </p>
                           <div className="flex flex-wrap gap-2 mt-2">
                              {grandTotals.companyNames.map((name, idx) => (
                                 <span
                                    key={idx}
                                    className={`
                                    px-2 py-1 text-xs rounded-full
                                    ${isDark ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-700'}
                                 `}>
                                    {name}
                                 </span>
                              ))}
                           </div>
                        </div>
                     </div>

                     {/* Net Profit/Loss Badge */}
                     <div className={`
                     px-6 py-3 rounded-xl text-center
                     ${isProfitable
                           ? (isDark ? 'bg-green-900/30 border border-green-700' : 'bg-green-100 border border-green-300')
                           : (isDark ? 'bg-red-900/30 border border-red-700' : 'bg-red-100 border border-red-300')
                        }
                  `}>
                        <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                           {isProfitable ? 'Net Profit' : 'Net Loss'}
                        </p>
                        <p className={`text-2xl font-bold ${isProfitable
                           ? (isDark ? 'text-green-400' : 'text-green-700')
                           : (isDark ? 'text-red-400' : 'text-red-700')
                           }`}>
                           ₹ {formatCurrency(Math.abs(grandTotals.netProfitLoss))}
                        </p>
                     </div>
                  </div>
               </div>

               {/* Stats Grid - Different layouts based on report type */}
               {reportType === 'Profit & Loss Monthly' && (
                  <div className="p-4 overflow-x-auto">
                     <div className="min-w-max">
                        <div className="grid gap-2" style={{ gridTemplateColumns: `200px repeat(${months.length}, 120px)` }}>
                           {/* Header */}
                           <div className={`p-3 rounded-t-lg font-bold ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}>
                              Monthly Totals
                           </div>
                           {months.map((month) => (
                              <div key={month} className={`p-3 rounded-t-lg text-center font-bold ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}>
                                 {month}
                              </div>
                           ))}

                           {/* Values */}
                           <div className={`p-3 ${isDark ? 'bg-gray-800' : 'bg-white'}`}>
                              Total Amount
                           </div>
                           {months.map((month) => (
                              <div key={month} className={`p-3 text-right font-mono ${isDark ? 'bg-gray-800' : 'bg-white'}`}>
                                 ₹ {formatCurrency(grandTotals.monthlyTotals[month] || 0)}
                              </div>
                           ))}
                        </div>
                     </div>
                  </div>
               )}

               {(reportType === 'Profit & Loss T Format' || reportType === 'Profit & Loss Vertical') && (
                  <div className="grid grid-cols-1 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-gray-200 dark:divide-gray-700">
                     {/* Total Amount Card */}
                     <div className="p-6">
                        <div className="flex items-center gap-4">
                           <div className={`
                           w-12 h-12 rounded-lg flex items-center justify-center
                           ${isDark ? 'bg-blue-900/30' : 'bg-blue-100'}
                        `}>
                              <span className="text-xl">💰</span>
                           </div>
                           <div>
                              <p className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                 Total Amount
                              </p>
                              <p className={`text-2xl font-bold ${isDark ? 'text-blue-400' : 'text-blue-700'}`}>
                                 ₹ {formatCurrency(grandTotals.totalAmount)}
                              </p>
                           </div>
                        </div>
                     </div>

                     {/* Total Debit Card */}
                     <div className="p-6">
                        <div className="flex items-center gap-4">
                           <div className={`
                           w-12 h-12 rounded-lg flex items-center justify-center
                           ${isDark ? 'bg-red-900/30' : 'bg-red-100'}
                        `}>
                              <span className="text-xl">📉</span>
                           </div>
                           <div>
                              <p className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                 Total Debit
                              </p>
                              <p className={`text-2xl font-bold ${isDark ? 'text-red-400' : 'text-red-700'}`}>
                                 ₹ {formatCurrency(grandTotals.totalDebit)}
                              </p>
                           </div>
                        </div>
                     </div>

                     {/* Total Credit Card */}
                     <div className="p-6">
                        <div className="flex items-center gap-4">
                           <div className={`
                           w-12 h-12 rounded-lg flex items-center justify-center
                           ${isDark ? 'bg-green-900/30' : 'bg-green-100'}
                        `}>
                              <span className="text-xl">📈</span>
                           </div>
                           <div>
                              <p className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                 Total Credit
                              </p>
                              <p className={`text-2xl font-bold ${isDark ? 'text-green-400' : 'text-green-700'}`}>
                                 ₹ {formatCurrency(grandTotals.totalCredit)}
                              </p>
                           </div>
                        </div>
                     </div>

                     {/* Net Result Card */}
                     <div className="p-6">
                        <div className="flex items-center gap-4">
                           <div className={`
                           w-12 h-12 rounded-lg flex items-center justify-center
                           ${isProfitable
                                 ? (isDark ? 'bg-green-900/30' : 'bg-green-100')
                                 : (isDark ? 'bg-red-900/30' : 'bg-red-100')
                              }
                        `}>
                              <span className="text-xl">⚖️</span>
                           </div>
                           <div>
                              <p className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                 Net Result
                              </p>
                              <p className={`text-2xl font-bold ${isProfitable
                                 ? (isDark ? 'text-green-400' : 'text-green-700')
                                 : (isDark ? 'text-red-400' : 'text-red-700')
                                 }`}>
                                 ₹ {formatCurrency(Math.abs(grandTotals.netProfitLoss))}
                                 <span className="text-sm ml-1">
                                    {isProfitable ? '(Profit)' : '(Loss)'}
                                 </span>
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
               )}
            </div>

            {/* Summary Stats Row */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
               <div className={`p-3 rounded-lg text-center ${isDark ? 'bg-gray-800' : 'bg-white'} shadow`}>
                  <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Categories</p>
                  <p className={`text-xl font-bold ${isDark ? 'text-indigo-400' : 'text-indigo-700'}`}>
                     {grandTotals.categoryCount}
                  </p>
               </div>
               <div className={`p-3 rounded-lg text-center ${isDark ? 'bg-gray-800' : 'bg-white'} shadow`}>
                  <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Items</p>
                  <p className={`text-xl font-bold ${isDark ? 'text-green-400' : 'text-green-700'}`}>
                     {grandTotals.itemCount}
                  </p>
               </div>
               <div className={`p-3 rounded-lg text-center ${isDark ? 'bg-gray-800' : 'bg-white'} shadow`}>
                  <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Companies</p>
                  <p className={`text-xl font-bold ${isDark ? 'text-purple-400' : 'text-purple-700'}`}>
                     {grandTotals.companyCount}
                  </p>
               </div>
               <div className={`p-3 rounded-lg text-center ${isDark ? 'bg-gray-800' : 'bg-white'} shadow`}>
                  <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Avg per Company</p>
                  <p className={`text-xl font-bold ${isDark ? 'text-orange-400' : 'text-orange-700'}`}>
                     ₹ {formatCurrency(grandTotals.totalAmount / grandTotals.companyCount)}
                  </p>
               </div>
            </div>
         </Box>
      );
   });

   useEffect(() => {
      const handleKeyDown = (e) => {
         const isTargetInput =
            e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA' ||
            e.target.tagName === 'SELECT' ||
            e.target.isContentEditable;

         if (e.key.toLowerCase() === 't' && !isTargetInput) {
            if (fromDateInputRef.current) {
               fromDateInputRef.current.focus();
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   const downloadExcel = () => {
      if (reportType === 'Profit & Loss Monthly') {
         const allMonths = Array.from(
            new Set(
               ProfitLossMonthly.flatMap((company) =>
                  company.data.flatMap((group) => (group.monthData ? Object.keys(group.monthData) : [])),
               ),
            ),
         ).sort((a, b) => {
            const monthsOrder = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
            const monthA = a.split('-')[0];
            const monthB = b.split('-')[0];
            return monthsOrder.indexOf(monthA) - monthsOrder.indexOf(monthB);
         });

         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };

         const headers = ['Account', ...allMonths];
         const finalData = [];
         const styles = [];

         ProfitLossMonthly.forEach((ProfitLossdata) => {
            // finalData.push([`${ProfitLossdata.companyName}`]);
            const companyNameRow = Array(headers.length).fill('');
            companyNameRow[0] = ProfitLossdata.companyName;
            finalData.push(companyNameRow);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F8FAFC' } },
                  alignment: { horizontal: 'left' },
               }),
            );

            finalData.push(headers);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
               }),
            );

            ProfitLossdata.data.forEach((group) => {
               finalData.push([group.type]);
               styles.push(
                  Array(headers.length).fill({
                     font: { bold: true, sz: 10, color: { rgb: colors.headerText } },
                  }),
               );

               group.data.forEach((groupdata) => {
                  const row = [];
                  const rowStyle = [];
                  row.push(groupdata.accountName || '');

                  allMonths.forEach((month) => {
                     const value = group.monthData?.[month] ?? 0;
                     row.push(value);
                  });

                  finalData.push(row);
                  styles.push(rowStyle);
               });

               finalData.push([]);
               styles.push([]);
            });

            finalData.push([]);
            styles.push([]);
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [
            { width: 40 }, // Account Name
            ...allMonths.map(() => ({ width: 15 })),
         ];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Profit & Loss Monthly');
         XLSX.writeFile(wb, 'ProfitLossMonthly.xlsx');
      }
      if (reportType === 'Profit & Loss T Format') {
         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };

         const categorizeProfitLossItems = (data) => {
            const debitItems = [];
            const creditItems = [];

            data.forEach((group) => {
               // Determine if this group belongs to debit or credit side
               const isDebitSide = [
                  'EXPENSES',
                  'COST OF GOODS SOLD',
                  'OPERATING EXPENSES',
                  'PURCHASES',
                  'DIRECT EXPENSES',
                  'INDIRECT EXPENSES',
                  'PURCHASE',
                  'JOB CHARGE',
                  'PACKAGING EXPENSES',
               ].some((type) => group.type.toUpperCase().includes(type.toUpperCase()));

               // Add individual items from this group
               group.data.forEach((item) => {
                  const itemData = {
                     account: item.accountName,
                     amount: Math.abs(Number(item.total || 0)),
                  };

                  if (isDebitSide) {
                     debitItems.push(itemData);
                  } else {
                     creditItems.push(itemData);
                  }
               });
            });

            return { debitItems, creditItems };
         };

         // Get the profit & loss data from the first company
         const ProfitLossData = ProfitLossMonthly[0].data;
         const { debitItems, creditItems } = categorizeProfitLossItems(ProfitLossData);

         // Calculate totals
         const totalDebits = debitItems.reduce((sum, item) => sum + Number(item.amount || 0), 0);
         const totalCredits = creditItems.reduce((sum, item) => sum + Number(item.amount || 0), 0);

         // Calculate profit/loss
         const profitLoss = totalCredits - totalDebits;
         const isProfitable = profitLoss > 0;

         // Balance the sides by adding profit/loss
         let finalDebitItems = [...debitItems];
         let finalCreditItems = [...creditItems];
         let finalAllData = [
            {
               debit: finalDebitItems,
               credit: finalCreditItems,
            },
         ];

         if (isProfitable) {
            finalDebitItems.push({
               account: 'NET PROFIT',
               amount: profitLoss,
               isTotal: true,
            });
         } else if (profitLoss < 0) {
            finalCreditItems.push({
               account: 'NET LOSS',
               amount: Math.abs(profitLoss),
               isTotal: true,
            });
         }

         // Calculate final totals
         const finalDebitTotal = totalDebits + (isProfitable ? profitLoss : 0);
         const finalCreditTotal = totalCredits + (!isProfitable ? Math.abs(profitLoss) : 0);

         // Determine the maximum number of rows to iterate
         const maxRows = Math.max(finalDebitItems.length, finalCreditItems.length);

         const headers = ['Particulars', 'Amount', '', 'Particulars', 'Amount'];
         const finalData = [];
         const styles = [];

         finalAllData.forEach((data) => {
            finalData.push(headers);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
               }),
            );
            let count = 0;

            while (count < maxRows) {
               finalData.push([
                  data?.debit?.[count]?.account || '',
                  data?.debit?.[count]?.amount || '',
                  '',
                  data?.credit?.[count]?.account || '',
                  data?.credit?.[count]?.amount || '',
               ]);

               styles.push(
                  Array(headers.length).fill({
                     font: { sz: 12, color: { rgb: colors.headerText } },
                  }),
               );

               count++;
            }

            finalData.push(['Total', finalDebitTotal, '', 'Total', finalCreditTotal]);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F8FAFC' } },
               }),
            );
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [{ width: 40 }, { width: 20 }, { width: 1 }, { width: 40 }, { width: 20 }];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Profit & Loss Monthly');
         XLSX.writeFile(wb, 'ProfitLossMonthly.xlsx');
      }
      if (reportType === 'Profit & Loss Vertical') {
         const formatCurrency = (value) => {
            if (value === null || value === undefined) return '-';
            const numValue = Number(value);
            if (isNaN(numValue)) return value;

            // Format with Indian numbering system (lakhs, crores)
            return new Intl.NumberFormat('en-IN', {
               maximumFractionDigits: 2,
            }).format(Math.abs(numValue));
         };

         const companyData = ProfitLossMonthly[0].data;

         // Create rows for rendering in the desired format
         const createRows = () => {
            const rows = [];

            // First group data by category
            const categories = {};
            companyData.forEach((group) => {
               if (!categories[group.type]) {
                  categories[group.type] = [];
               }
               categories[group.type].push(...group.data);
            });

            // Process each category
            Object.entries(categories).forEach(([category, items]) => {
               // Skip empty categories
               if (items.length === 0) return;

               // Add category header
               rows.push({
                  type: 'group',
                  account: category,
                  amount: '',
                  company: '',
               });

               // Add all items under this category
               items.forEach((item) => {
                  rows.push({
                     type: 'item',
                     account: item.accountName,
                     amount: formatCurrency(item.total),
                     company: companyData.companyName,
                  });
               });

               // Calculate category total
               const categoryTotal = items.reduce((sum, item) => sum + Math.abs(Number(item.total)), 0);

               // Add category total
               rows.push({
                  type: 'subtotal',
                  account: `Total`,
                  amount: formatCurrency(categoryTotal),
               });

               // Add empty row for spacing
               rows.push({
                  type: 'spacer',
                  account: '',
                  amount: '',
               });
            });

            return rows;
         };

         const rows = createRows();

         const getRowStyle = (type) => {
            switch (type) {
               case 'group':
                  return {
                     font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                     fill: { patternType: 'solid', fgColor: { rgb: 'F1F5F9' } }, // light gray background
                  };
               case 'subtotal':
                  return {
                     font: { bold: true, sz: 12 },
                     border: {
                        top: { style: 'thin', color: { rgb: 'CCCCCC' } },
                        bottom: { style: 'thin', color: { rgb: 'CCCCCC' } },
                     },
                  };
               case 'spacer':
                  return {}; // Excel doesn't support row height via styles here
               default:
                  return {
                     font: { sz: 12, color: { rgb: colors.headerText } },
                  };
            }
         };

         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };

         const headers = ['Account', 'Amount'];
         const finalData = [];
         const styles = [];

         finalData.push(headers);
         styles.push(
            Array(headers.length).fill({
               font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
            }),
         );
         rows.forEach((data) => {
            finalData.push([data?.account, data?.amount]);
            const rowStyle = getRowStyle(data.type);
            styles.push(Array(headers.length).fill(rowStyle));
         });

         finalData.push([]);
         styles.push([]);

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [
            { width: 40 }, // Account Name
         ];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Profit & Loss Monthly');
         XLSX.writeFile(wb, 'ProfitLossMonthly.xlsx');
      }
   };

   const downloadPDF = () => {
      const doc = new jsPDF({
         orientation: reportType === 'Profit & Loss T Format' ? 'landscape' : 'portrait',
         unit: 'mm',
         format: 'a4',
      });

      // Set document properties
      doc.setProperties({
         title: 'Profit & Loss Report',
         subject: reportType,
         author: 'Your App Name',
         keywords: 'profit, loss, financial, report',
         creator: 'Your App Name',
      });

      // Frontend color mapping
      const colors = {
         white: [255, 255, 255],
         companyBg: [230, 239, 252], // rgba(0, 63, 140, 0.1)
         evenRowBg: [255, 255, 255],
         oddRowBg: [240, 248, 255], // rgba(0, 63, 140, 0.05)
         tableHeaderBg: [245, 245, 245], // #F5F5F5
         groupHeaderBg: [230, 245, 255], // rgba(0, 63, 140, 0.15)
         tFormatHeaderBg: [230, 245, 255],
         textColor: [33, 37, 41],
         borderColor: [206, 212, 218],
         profitColor: [46, 125, 50],
         lossColor: [211, 47, 47],
         profitBg: [230, 255, 237],
         lossBg: [255, 235, 238],
      };

      // Format currency exactly like frontend
      const formatCurrency = (value) => {
         if (value === null || value === undefined) return '-';
         const numValue = Number(value);
         if (isNaN(numValue)) return value;
         return new Intl.NumberFormat('en-IN', {
            maximumFractionDigits: 2,
         }).format(Math.abs(numValue));
      };

      // Add header
      const addHeader = () => {
         doc.setFontSize(14);
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(...colors.textColor);
         doc.text(reportType, doc.internal.pageSize.width / 2, 15, { align: 'center' });

         doc.setFontSize(10);
         doc.setFont('helvetica', 'normal');
         doc.text(
            `Date Range: ${datePartyWiseSalesRange?.fromDate || fromDate} to ${datePartyWiseSalesRange?.toDate || toDate
            }`,
            doc.internal.pageSize.width / 2,
            20,
            { align: 'center' },
         );
      };

      addHeader();

      if (reportType === 'Profit & Loss Monthly') {
         let startY = 25;
         const pageWidth = doc.internal.pageSize.width;
         const margin = 10;
         const contentWidth = pageWidth - margin * 2;

         ProfitLossMonthly.forEach((company, companyIndex) => {
            // Company header with frontend styling
            doc.setFillColor(...colors.companyBg);
            doc.rect(margin, startY - 3, contentWidth, 8, 'F');

            doc.setFontSize(8);
            doc.setTextColor(...colors.textColor);
            doc.setFont('helvetica', 'bold');
            doc.text(company.companyName, margin + 3, startY + 2);
            startY += 7;

            // Get all months like frontend
            const allMonths = Array.from(
               new Set(company.data.flatMap((group) => (group.monthData ? Object.keys(group.monthData) : []))),
            ).sort((a, b) => {
               const monthsOrder = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
               const monthA = a.split('-')[0];
               const monthB = b.split('-')[0];
               return monthsOrder.indexOf(monthA) - monthsOrder.indexOf(monthB);
            });

            // Calculate column widths
            const accountColWidth = 60;
            const monthColWidth = allMonths.length > 0 ? (contentWidth - accountColWidth) / allMonths.length : 30;

            // Draw table header
            doc.setFillColor(...colors.tableHeaderBg);
            doc.rect(margin, startY, contentWidth, 8, 'F');

            doc.setFontSize(8);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(...colors.textColor);

            // Account header
            doc.text('Account', margin + 2, startY + 5);

            // Month headers
            allMonths.forEach((month, index) => {
               const x = margin + accountColWidth + index * monthColWidth;
               doc.text(month, x + 2, startY + 5);
            });

            startY += 10;

            // Draw data exactly like frontend structure
            company.data.forEach((group, groupIndex) => {
               // Group header row - matches frontend styling
               doc.setFillColor(...colors.groupHeaderBg);
               doc.rect(margin, startY, contentWidth, 7, 'F');
               doc.setFontSize(8);
               doc.setFont('helvetica', 'bold');
               doc.setTextColor(...colors.textColor);
               doc.text(group.type, margin + 2, startY + 4);
               startY += 8;

               // Group items
               group.data.forEach((item, itemIndex) => {
                  // Alternate row colors like frontend
                  if (itemIndex % 2 === 1) {
                     doc.setFillColor(...colors.oddRowBg);
                     doc.rect(margin, startY, contentWidth, 6, 'F');
                  }

                  doc.setFontSize(8);
                  doc.setFont('helvetica', 'normal');
                  doc.setTextColor(...colors.textColor);

                  // Account name (indented like frontend)
                  doc.text(item.accountName || '-', margin + 8, startY + 4);

                  // Month values
                  allMonths.forEach((month, monthIndex) => {
                     const monthValue = group.monthData && group.monthData[month] ? Number(group.monthData[month]) : 0;
                     const x = margin + accountColWidth + monthIndex * monthColWidth;
                     doc.text(formatCurrency(monthValue), x + monthColWidth - 2, startY + 4, { align: 'right' });
                  });

                  startY += 6;
               });

               // Add spacing between groups like frontend
               startY += 3;

               // Check page break
               if (startY > 250) {
                  doc.addPage();
                  addHeader();
                  startY = 35;
               }
            });

            startY += 10; // Space between companies
         });
      } else if (reportType === 'Profit & Loss Vertical') {
         const companyData = ProfitLossMonthly[0]?.data || [];
         let startY = 25;
         const pageWidth = doc.internal.pageSize.width;
         const margin = 15;
         const contentWidth = pageWidth - margin * 2;

         // Group data exactly like frontend
         const categories = {};
         companyData.forEach((group) => {
            if (!categories[group.type]) {
               categories[group.type] = [];
            }
            categories[group.type].push(...group.data);
         });

         Object.entries(categories).forEach(([category, items]) => {
            if (items.length === 0) return;

            // Category header - matches frontend group styling
            doc.setFillColor(...colors.groupHeaderBg);
            doc.rect(margin, startY - 2, contentWidth, 8, 'F');

            doc.setFontSize(8);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(...colors.textColor);
            doc.text(category.toUpperCase(), margin + 5, startY + 3);
            startY += 10;

            // Category items
            items.forEach((item, index) => {
               // Alternate row colors like frontend
               if (index % 2 === 1) {
                  doc.setFillColor(...colors.oddRowBg);
                  doc.rect(margin, startY, contentWidth, 6, 'F');
               }

               doc.setFontSize(8);
               doc.setFont('helvetica', 'normal');
               doc.setTextColor(...colors.textColor);

               // Account name
               doc.text(item.accountName, margin + 5, startY + 4);

               // Amount (right aligned)
               doc.text(formatCurrency(item.total), pageWidth - margin - 5, startY + 4, { align: 'right' });

               startY += 6;
            });

            // Category total with frontend subtotal styling
            const categoryTotal = items.reduce((sum, item) => sum + Math.abs(Number(item.total || 0)), 0);

            doc.setDrawColor(...colors.borderColor);
            doc.line(margin, startY, pageWidth - margin, startY); // Top border
            doc.line(margin, startY + 6, pageWidth - margin, startY + 6); // Bottom border

            doc.setFontSize(8);
            doc.setFont('helvetica', 'bold');
            doc.text('Total', margin + 5, startY + 4);
            doc.text(formatCurrency(categoryTotal), pageWidth - margin - 5, startY + 4, { align: 'right' });

            startY += 12; // Extra spacing after category

            // Check page break
            if (startY > 250) {
               doc.addPage();
               addHeader();
               startY = 35;
            }
         });
      } else if (reportType === 'Profit & Loss T Format') {
         const companyData = ProfitLossMonthly[0]?.data || [];

         // Categorize items exactly like frontend
         const categorizeItems = (data) => {
            const debitItems = [];
            const creditItems = [];

            data.forEach((group) => {
               const isDebitSide = [
                  'EXPENSES',
                  'COST OF GOODS SOLD',
                  'OPERATING EXPENSES',
                  'PURCHASES',
                  'DIRECT EXPENSES',
                  'INDIRECT EXPENSES',
                  'PURCHASE',
                  'JOB CHARGE',
                  'PACKAGING EXPENSES',
               ].some((type) => group.type.toUpperCase().includes(type.toUpperCase()));

               group.data.forEach((item) => {
                  const itemData = {
                     account: item.accountName,
                     amount: Math.abs(Number(item.total || 0)),
                  };

                  if (isDebitSide) {
                     debitItems.push(itemData);
                  } else {
                     creditItems.push(itemData);
                  }
               });
            });

            return { debitItems, creditItems };
         };

         const { debitItems, creditItems } = categorizeItems(companyData);
         const totalDebits = debitItems.reduce((sum, item) => sum + item.amount, 0);
         const totalCredits = creditItems.reduce((sum, item) => sum + item.amount, 0);
         const profitLoss = totalCredits - totalDebits;
         const isProfitable = profitLoss > 0;

         // Balance sides like frontend
         let finalDebitItems = [...debitItems];
         let finalCreditItems = [...creditItems];

         if (isProfitable) {
            finalDebitItems.push({ account: 'NET PROFIT', amount: profitLoss, isTotal: true });
         } else if (profitLoss < 0) {
            finalCreditItems.push({ account: 'NET LOSS', amount: Math.abs(profitLoss), isTotal: true });
         }

         const pageWidth = doc.internal.pageSize.width;
         const margin = 10;
         const colWidth = (pageWidth - margin * 2 - 8) / 4; // 4 columns with spacer
         let startY = 35;

         // T-Format header
         doc.setFillColor(...colors.tFormatHeaderBg);
         doc.rect(margin, startY, pageWidth - margin * 2, 8, 'F');

         doc.setFontSize(8);
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(...colors.textColor);

         // Header labels
         doc.text('Particulars', margin + 5, startY + 5);
         doc.text('Amount', margin + colWidth - 5, startY + 5, { align: 'right' });
         doc.text('Particulars', margin + colWidth * 2 + 8 + 5, startY + 5);
         doc.text('Amount', margin + colWidth * 4 + 8 - 5, startY + 5, { align: 'right' });

         startY += 12;

         // T-Format data rows
         const maxRows = Math.max(finalDebitItems.length, finalCreditItems.length);

         for (let i = 0; i < maxRows; i++) {
            const debitItem = finalDebitItems[i];
            const creditItem = finalCreditItems[i];

            // Row background for alternating colors
            if (i % 2 === 1 && !debitItem?.isTotal && !creditItem?.isTotal) {
               doc.setFillColor(...colors.oddRowBg);
               doc.rect(margin, startY, pageWidth - margin * 2, 6, 'F');
            }

            // Special styling for net result
            if (debitItem?.isTotal || creditItem?.isTotal) {
               const bgColor = isProfitable ? colors.profitBg : colors.lossBg;
               doc.setFillColor(...bgColor);
               doc.rect(margin, startY, pageWidth - margin * 2, 6, 'F');
            }

            doc.setFontSize(8);
            doc.setFont('helvetica', debitItem?.isTotal || creditItem?.isTotal ? 'bold' : 'normal');

            let textColor = colors.textColor;
            if (debitItem?.isTotal || creditItem?.isTotal) {
               textColor = isProfitable ? colors.profitColor : colors.lossColor;
            }
            doc.setTextColor(...textColor);

            // Debit side
            if (debitItem) {
               doc.text(debitItem.account, margin + 2, startY + 4);
               doc.text(formatCurrency(debitItem.amount), margin + colWidth - 2, startY + 4, { align: 'right' });
            }

            // Credit side
            if (creditItem) {
               doc.text(creditItem.account, margin + colWidth * 2 + 8 + 2, startY + 4);
               doc.text(formatCurrency(creditItem.amount), margin + colWidth * 4 + 8 - 2, startY + 4, {
                  align: 'right',
               });
            }

            startY += 6;
         }

         // Total row
         doc.setDrawColor(...colors.borderColor);
         doc.line(margin, startY, pageWidth - margin, startY);

         doc.setFillColor(...colors.borderColor);
         doc.rect(margin, startY + 1, pageWidth - margin * 2, 7, 'F');

         doc.setFontSize(8);
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(...colors.textColor);

         const finalDebitTotal = totalDebits + (isProfitable ? profitLoss : 0);
         const finalCreditTotal = totalCredits + (!isProfitable ? Math.abs(profitLoss) : 0);

         doc.text('TOTAL', margin + 2, startY + 5);
         doc.text(formatCurrency(finalDebitTotal), margin + colWidth - 2, startY + 5, { align: 'right' });
         doc.text('TOTAL', margin + colWidth * 2 + 8 + 2, startY + 5);
         doc.text(formatCurrency(finalCreditTotal), margin + colWidth * 4 + 8 - 2, startY + 5, { align: 'right' });
      }

      // Footer
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
         doc.setPage(i);
         doc.setFontSize(8);
         doc.setTextColor(...colors.textColor);
         doc.text(
            `Generated: ${new Date().toLocaleDateString('en-IN')} | Page ${i} of ${pageCount}`,
            doc.internal.pageSize.width / 2,
            doc.internal.pageSize.height - 10,
            { align: 'center' },
         );
      }

      doc.save(`${reportType.replace(/ /g, '_')}_Report.pdf`);
   };

   const ColumnVisibilityModal = () => (
      <Modal isOpen={isColumnSelectorOpen} onClose={() => setIsColumnSelectorOpen(false)} size="md">
         <ModalOverlay />
         <ModalContent>
            <ModalHeader>Show/Hide Columns</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               {columns.map((column) => (
                  <Flex key={column.id} mb={2} alignItems="center">
                     <Checkbox
                        isChecked={!!columnVisibility[column.id]}
                        onChange={(e) => {
                           table.setColumnVisibility((prev) => ({
                              ...prev,
                              [column.id]: e.target.checked,
                           }));
                        }}
                        mr={2}
                     />
                     <Text>{column.header}</Text>
                  </Flex>
               ))}
            </ModalBody>
            <ModalFooter>
               <Button colorScheme="blue" onClick={() => setIsColumnSelectorOpen(false)}>
                  Close
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );

   const renderVerticalFormatProfitLossMonthly = () => {
      // Check if data exists
      if (
         !ProfitLossMonthly ||
         ProfitLossMonthly.length === 0 ||
         !ProfitLossMonthly[0]?.data ||
         ProfitLossMonthly[0].data.length === 0
      ) {
         return (
            <>
               <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
                  <Td
                     p="2px"
                     py="3px"
                     fontSize="10px"
                     whiteSpace="nowrap"
                     textOverflow="ellipsis"
                     maxW="150px"
                     overflow="hidden"
                     colSpan={2}
                     justifyContent="center"
                     alignItems="center"
                     width="100%">
                     <Grid justifyContent="center" alignItems="center" gap={9}>
                        <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                        <GridItem justifySelf="center">
                           <label>No profit and loss data found</label>
                        </GridItem>
                     </Grid>
                  </Td>
               </Tr>
            </>
         );
      }

      // Helper function to format currency with smaller decimal font size
      const formatCurrencyWithSmallDecimal = (value) => {
         if (value === null || value === undefined) return '-';
         const numValue = Number(value);
         if (isNaN(numValue)) return value;

         // Format with Indian numbering system
         const formatted = new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
         }).format(Math.abs(numValue));

         // Split into integer and decimal parts for smaller decimal font
         const parts = formatted.split('.');
         if (parts.length === 2) {
            return (
               <>
                  {parts[0]}.<span style={{ fontSize: '10px' }}>{parts[1]}</span>
               </>
            );
         }
         return formatted;
      };

      // Extract the company data
      const companyData = ProfitLossMonthly[0].data;
      console.log("ProfitLossMonthly", ProfitLossMonthly);

      // Create rows for rendering in the desired format
      const createRows = () => {
         const rows = [];

         // First group data by category
         const categories = {};
         companyData.forEach((group) => {
            if (!categories[group.type]) {
               categories[group.type] = [];
            }
            categories[group.type].push(...group.data);
         });

         // Process each category
         Object.entries(categories).forEach(([category, items]) => {
            // Skip empty categories
            if (items.length === 0) return;

            // Add category header
            rows.push({
               type: 'group',
               account: category,
               amount: '',
               company: '',
            });

            // Add all items under this category
            items.forEach((item) => {
               rows.push({
                  type: 'item',
                  account: item.accountName,
                  amount: formatCurrencyWithSmallDecimal(item.total),
                  company: companyData.companyName,
               });
            });

            // Calculate category total
            const categoryTotal = items.reduce((sum, item) => sum + Math.abs(Number(item.total)), 0);

            // Add category total
            rows.push({
               type: 'subtotal',
               account: `Total`,
               amount: formatCurrencyWithSmallDecimal(categoryTotal),
            });

            // Add empty row for spacing
            rows.push({
               type: 'spacer',
               account: '',
               amount: '',
            });
         });

         return rows;
      };

      // const rows = createRows();
      const rows = [];

      ProfitLossMonthly.forEach((company) => {

         // ✅ Add company name row
         rows.push({
            type: 'company',
            account: company.companyName,
            amount: '',
         });

         const categories = {};

         company?.data?.forEach((group) => {

            if (!categories[group.type]) {
               categories[group.type] = [];
            }

            categories[group.type].push(...group.data);

         });


         Object.entries(categories).forEach(([category, items]) => {

            if (items.length === 0) return;

            rows.push({
               type: 'group',
               account: category,
               amount: '',
            });


            items.forEach((item) => {

               rows.push({
                  type: 'item',
                  account: item.accountName,
                  amount: formatCurrencyWithSmallDecimal(item.total),
               });

            });


            const categoryTotal =
               items.reduce((sum, item) =>
                  sum + Math.abs(Number(item.total)), 0);


            rows.push({
               type: 'subtotal',
               account: `Total`,
               amount: formatCurrencyWithSmallDecimal(categoryTotal),
            });


            rows.push({
               type: 'spacer',
               account: '',
               amount: '',
            });

         });

      });

      // Get styling based on row type
      const getRowStyle = (type) => {
         switch (type) {
            case 'company':
               return {
                  fontWeight: 'bold',
                  fontSize: '20px',
                  bg: companyBg,
               };
            case 'group':
               return {
                  fontWeight: 'bold',
                  fontSize: '16px',
                  bg: companyBg,
                  textTransform: 'uppercase',
               };
            case 'subtotal':
               return {
                  fontWeight: 'bold',
                  borderTop: '1px solid',
                  borderBottom: '1px solid',
                  borderColor: 'gray.200',
               };
            case 'spacer':
               return {
                  height: '10px',
               };
            default:
               return {};
         }
      };

      return (
         <>
            <>
               {rows.map((row, index) => (
                  <Tr
                     key={`row-${index}`}
                     bg={row.type === 'item' && index % 2 === 0 ? 'white' : 'transparent'}
                     _dark={{ bg: row.type === 'item' && index % 2 === 0 ? '#101F4A' : 'transparent' }}>
                     {/* Account Name Column */}
                     <Td
                        p="2px"
                        fontSize={'14px'}
                        color={textColor}
                        borderColor={borderColor}
                        {...getRowStyle(row.type)}
                        fontWeight={row.type === 'item' ? 'normal' : 'bold'}>
                        {row.account}
                     </Td>

                     {/* Amount Column */}
                     <Td
                        p="2px"
                        fontSize={'14px'}
                        color={textColor}
                        borderColor={borderColor}
                        textAlign="right"
                        {...getRowStyle(row.type)}
                        fontWeight={row.type === 'item' ? 'normal' : 'bold'}>
                        {row.amount}
                     </Td>
                  </Tr>
               ))}
            </>
         </>
      );
   };

   const renderTFormatProfitLossMonthly = () => {
      // ─── Guard ───────────────────────────────────────────────
      if (!ProfitLossMonthly || ProfitLossMonthly.length === 0) {
         return (
            <Tr>
               <Td colSpan={4} textAlign="center" py="100px">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label>No profit and loss data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      // ─── Helpers ─────────────────────────────────────────────
      const fmt = (value) => {
         if (value === null || value === undefined) return '-';
         const n = Number(value);
         if (isNaN(n)) return '-';
         const formatted = new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
         }).format(Math.abs(n));
         const [int, dec] = formatted.split('.');
         return (
            <>
               {int}.<span style={{ fontSize: '10px' }}>{dec}</span>
            </>
         );
      };

      // Keywords that classify a group as TRADING side (debit / expense)
      const TRADING_EXPENSE_TYPES = [
         'TRADING EXPENSES',
         'COST OF GOODS SOLD',
         'PURCHASES',
         'PURCHASE',
         'DIRECT EXPENSES',
         'OPENING STOCK',
      ];

      // Keywords that classify a group as P&L expense side
      const PNL_EXPENSE_TYPES = [
         'P&L EXPENSES',
         'INDIRECT EXPENSES',
         'OPERATING EXPENSES',
         'EXPENSES',
         'JOB CHARGE',
         'PACKAGING EXPENSES',
      ];

      // ─── Shared cell styles ───────────────────────────────────
      const thStyle = {
         bg: '#E0F2FE',
         color: '#075985',
         fontWeight: 'bold',
         fontSize: '13px',
         p: '8px 10px',
         _dark: { bg: '#1E3A8A', color: '#DBEAFE' },
         borderColor,
      };

      const groupTdStyle = {
         fontWeight: '700',
         fontSize: '13px',
         bg: 'rgba(0,63,140,0.08)',
         _dark: { bg: 'rgba(2,14,56,0.7)' },
         color: textColor,
         p: '6px 10px',
         borderColor,
      };

      const itemTdStyle = (idx) => ({
         fontSize: '13px',
         color: textColor,
         p: '5px 10px',
         borderColor,
         bg: idx % 2 === 0 ? 'white' : 'rgba(0,63,140,0.04)',
         _dark: { bg: idx % 2 === 0 ? '#101F4A' : 'rgba(2,14,56,0.6)' },
      });

      const subtotalTdStyle = {
         fontWeight: '700',
         fontSize: '13px',
         color: textColor,
         p: '6px 10px',
         borderTop: '1px solid',
         borderColor,
         bg: '#F8FAFC',
         _dark: { bg: '#0D1B3E' },
      };

      const grandTotalTdStyle = {
         fontWeight: '800',
         fontSize: '14px',
         color: textColor,
         p: '8px 10px',
         borderTop: '2px solid',
         borderColor: '#8A183C',
         bg: '#FDECEC',
         _dark: { bg: '#3B1F26', borderColor: '#8A183C' },
      };

      const bridgeTdStyle = (profitable) => ({
         fontWeight: '700',
         fontSize: '13px',
         color: profitable ? '#1D9E75' : '#E24B4A',
         p: '6px 10px',
         borderLeft: `3px solid ${profitable ? '#1D9E75' : '#E24B4A'}`,
         bg: profitable ? 'rgba(29,158,117,0.06)' : 'rgba(226,75,74,0.06)',
         _dark: {
            bg: profitable ? 'rgba(29,158,117,0.12)' : 'rgba(226,75,74,0.12)',
         },
         borderColor,
      });

      // ─── Per-company renderer ─────────────────────────────────
      return (
         <>
            {ProfitLossMonthly.map((company, companyIndex) => {
               const allGroups = company.data || [];

               // ── Helper: merge API groups that share the same `type` string ──
               // The API sends each item as its own group object with the same type.
               // We collapse them into one group per unique type name.
               const mergeGroupsByType = (groups) => {
                  const map = new Map();
                  groups.forEach((group) => {
                     const key = group.type;
                     if (!map.has(key)) {
                        map.set(key, {
                           type: key,
                           typeTotal: 0,
                           data: [],
                        });
                     }
                     const existing = map.get(key);
                     // Accumulate typeTotal (take the last non-zero value from API or sum items)
                     existing.typeTotal = Number(group.typeTotal || existing.typeTotal);
                     existing.data.push(...(group.data || []));
                  });
                  return Array.from(map.values());
               };

               // Bucket groups into 4 categories
               const rawTradingExpenseGroups = [];
               const rawTradingIncomeGroups = [];
               const rawPnlExpenseGroups = [];
               const rawPnlIncomeGroups = [];

               allGroups.forEach((group) => {
                  const typeUpper = (group.type || '').toUpperCase();

                  const isTradingExpense = TRADING_EXPENSE_TYPES.some((t) =>
                     typeUpper.includes(t)
                  );
                  const isPnlExpense = PNL_EXPENSE_TYPES.some((t) =>
                     typeUpper.includes(t)
                  );
                  const isTradingIncome = typeUpper.includes('TRADING INCOME');
                  const isPnlIncome =
                     typeUpper.includes('P&L INCOME') ||
                     typeUpper.includes('INDIRECT INCOME') ||
                     typeUpper.includes('OTHER INCOME');

                  if (isTradingExpense) rawTradingExpenseGroups.push(group);
                  else if (isTradingIncome) rawTradingIncomeGroups.push(group);
                  else if (isPnlExpense) rawPnlExpenseGroups.push(group);
                  else if (isPnlIncome) rawPnlIncomeGroups.push(group);
                  else {
                     rawPnlExpenseGroups.push(group);
                  }
               });

               // Merge duplicates — now each type appears only ONCE
               const tradingExpenseGroups = mergeGroupsByType(rawTradingExpenseGroups);
               const tradingIncomeGroups = mergeGroupsByType(rawTradingIncomeGroups);
               const pnlExpenseGroups = mergeGroupsByType(rawPnlExpenseGroups);
               const pnlIncomeGroups = mergeGroupsByType(rawPnlIncomeGroups);

               // Totals from API
               const grossProfit = company.grossProfit ?? 0;
               const netProfit = company.companyTotal ?? 0;
               const debitTotal = company.companyDebitTotal ?? 0;
               const creditTotal = company.companyCreditTotal ?? 0;

               const isGrossProfitable = grossProfit >= 0;
               const isNetProfitable = netProfit >= 0;

               // Helper: render one side of the T (a list of groups with items)
               const renderSide = (groups, side /* 'left'|'right' */) => {
                  const rows = [];
                  let globalItemIdx = 0;

                  groups.forEach((group, gi) => {
                     // Group header
                     rows.push(
                        <Tr key={`${side}-gh-${gi}`}>
                           <Td colSpan={2} {...groupTdStyle}>
                              {group.type}
                           </Td>
                        </Tr>
                     );

                     // Items
                     (group.data || []).forEach((item, ii) => {
                        const idx = globalItemIdx++;
                        rows.push(
                           <Tr key={`${side}-item-${gi}-${ii}`}>
                              <Td {...itemTdStyle(idx)} pl="22px" width="65%">
                                 {item.accountName}
                              </Td>
                              <Td {...itemTdStyle(idx)} textAlign="right" width="35%">
                                 {fmt(item.total)}
                              </Td>
                           </Tr>
                        );
                     });
                  });

                  return rows;
               };

               // ── TRADING SECTION ───────────────────────────────
               // Left : trading expenses  |  Right : trading income
               // Both sides balanced with subtotals + Gross P/L bridge row

               // Trading expense subtotal (sum of all typeTotal on expense side)
               const tradingExpenseSubtotal = tradingExpenseGroups.reduce(
                  (s, g) => s + Math.abs(Number(g.typeTotal || 0)), 0
               );
               const tradingIncomeSubtotal = tradingIncomeGroups.reduce(
                  (s, g) => s + Math.abs(Number(g.typeTotal || 0)), 0
               );

               // The balancing row: Gross Profit goes on the expense (left) side
               //                    Gross Loss  goes on the income  (right) side
               const tradingLeftTotal = isGrossProfitable
                  ? tradingExpenseSubtotal + Math.abs(grossProfit)   // expense side absorbs GP
                  : tradingExpenseSubtotal;
               const tradingRightTotal = isGrossProfitable
                  ? tradingIncomeSubtotal
                  : tradingIncomeSubtotal + Math.abs(grossProfit);   // income side absorbs GL

               // ── P&L SECTION ───────────────────────────────────
               const pnlExpenseSubtotal = pnlExpenseGroups.reduce(
                  (s, g) => s + Math.abs(Number(g.typeTotal || 0)), 0
               );
               const pnlIncomeSubtotal = pnlIncomeGroups.reduce(
                  (s, g) => s + Math.abs(Number(g.typeTotal || 0)), 0
               );

               // The Gross result carried forward sits on the debit side of P&L
               const pnlLeftWithGross = Math.abs(grossProfit) + pnlExpenseSubtotal;
               const pnlRightSubtotal = pnlIncomeSubtotal;

               // Net result bridge
               const pnlLeftTotal = isNetProfitable
                  ? pnlLeftWithGross + Math.abs(netProfit)
                  : pnlLeftWithGross;
               const pnlRightTotal = isNetProfitable
                  ? pnlRightSubtotal
                  : pnlRightSubtotal + Math.abs(netProfit);

               // ── Column header row ─────────────────────────────
               const HeaderRow = () => (
                  <Tr>
                     <Td {...thStyle} width="32%">Particulars</Td>
                     <Td {...thStyle} width="18%" textAlign="right">Amount</Td>
                     <Td {...thStyle} width="32%">Particulars</Td>
                     <Td {...thStyle} width="18%" textAlign="right">Amount</Td>
                  </Tr>
               );

               // ── Render a paired T row (left cell pair + right cell pair) ──
               // We build each section as two independent column tables merged
               // into a 4-column <Table>.  We collect left rows and right rows
               // separately then zip them into <Tr> with 4 <Td>s.

               const buildSideRows = (groups) => {
                  const rows = [];
                  let idx = 0;
                  groups.forEach((group) => {
                     // Show group header with its typeTotal in the amount column
                     rows.push({
                        isGroup: true,
                        label: group.type,
                        amount: group.typeTotal,   // ← typeTotal shown on group header row
                     });
                     (group.data || []).forEach((item) => {
                        rows.push({
                           isGroup: false,
                           label: item.accountName,
                           amount: item.total,
                           idx: idx++,
                        });
                     });
                  });
                  return rows;
               };

               const zipRows = (leftRows, rightRows, sectionKey) => {
                  const len = Math.max(leftRows.length, rightRows.length);
                  const result = [];
                  for (let i = 0; i < len; i++) {
                     const L = leftRows[i] || null;
                     const R = rightRows[i] || null;

                     const rowBg =
                        (!L || L.isGroup) && (!R || R.isGroup)
                           ? undefined
                           : (L && !L.isGroup && L.idx % 2 !== 0) || (R && !R.isGroup && R.idx % 2 !== 0)
                              ? 'rgba(0,63,140,0.04)'
                              : 'white';

                     result.push(
                        <Tr
                           key={`${sectionKey}-zip-${i}`}
                           bg={rowBg}
                           _dark={{ bg: rowBg === 'white' ? '#101F4A' : 'rgba(2,14,56,0.55)' }}
                        >
                           {/* Left particulars */}
                           <Td
                              p={L?.isGroup ? '6px 10px' : '5px 10px 5px 22px'}
                              fontSize="13px"
                              fontWeight={L?.isGroup ? '700' : '500'}
                              color={textColor}
                              bg={L?.isGroup ? 'rgba(0,63,140,0.08)' : undefined}
                              _dark={{ bg: L?.isGroup ? 'rgba(2,14,56,0.7)' : undefined }}
                              borderColor={borderColor}
                              width="32%"
                           >
                              {L?.label ?? ''}
                           </Td>

                           {/* Left amount */}
                           <Td
                              p="5px 10px"
                              fontSize="13px"
                              fontWeight={L?.isGroup ? '700' : '500'}
                              color={textColor}
                              bg={L?.isGroup ? 'rgba(0,63,140,0.08)' : undefined}
                              _dark={{ bg: L?.isGroup ? 'rgba(2,14,56,0.7)' : undefined }}
                              textAlign="right"
                              borderColor={borderColor}
                              width="18%"
                              borderRight="2px solid"
                           >
                              {L ? fmt(L.amount) : ''}
                           </Td>

                           {/* Right particulars */}
                           <Td
                              p={R?.isGroup ? '6px 10px' : '5px 10px 5px 22px'}
                              fontSize="13px"
                              fontWeight={R?.isGroup ? '700' : '500'}
                              color={textColor}
                              bg={R?.isGroup ? 'rgba(0,63,140,0.08)' : undefined}
                              _dark={{ bg: R?.isGroup ? 'rgba(2,14,56,0.7)' : undefined }}
                              borderColor={borderColor}
                              width="32%"
                           >
                              {R?.label ?? ''}
                           </Td>

                           {/* Right amount */}
                           <Td
                              p="5px 10px"
                              fontSize="13px"
                              fontWeight={R?.isGroup ? '700' : '500'}
                              color={textColor}
                              bg={R?.isGroup ? 'rgba(0,63,140,0.08)' : undefined}
                              _dark={{ bg: R?.isGroup ? 'rgba(2,14,56,0.7)' : undefined }}
                              textAlign="right"
                              borderColor={borderColor}
                              width="18%"
                           >
                              {R ? fmt(R.amount) : ''}
                           </Td>
                        </Tr>
                     );
                  }
                  return result;
               };

               // Build trading side row arrays
               const tradingLeftRows = buildSideRows(tradingExpenseGroups);
               const tradingRightRows = buildSideRows(tradingIncomeGroups);

               // Build P&L side row arrays — prepend Gross result carried forward on left
               const grossCarryRow = {
                  isGroup: false,
                  label: isGrossProfitable ? 'GROSS PROFIT' : 'GROSS LOSS',
                  amount: Math.abs(grossProfit),
                  idx: 0,
                  isSpecial: true,
               };
               const pnlLeftRows = [grossCarryRow, ...buildSideRows(pnlExpenseGroups).map((r, i) => ({ ...r, idx: i + 1 }))];
               const pnlRightRows = buildSideRows(pnlIncomeGroups);

               return (
                  <React.Fragment key={`company-${companyIndex}`}>

                     {/* ── Company name banner ─────────────────────── */}
                     <Tr bg="#F9EEEE" _dark={{ bg: '#2D1020' }}>
                        <Td
                           colSpan={4}
                           fontWeight="bold"
                           fontSize="16px"
                           color="#8A183C"
                           p="10px 14px"
                           _dark={{ color: '#F9A8D4' }}
                        >
                           {company.companyName}
                        </Td>
                     </Tr>

                     {/* ════════════════════════════════════════════
                TRADING ACCOUNT SECTION
            ════════════════════════════════════════════ */}
                     <Tr bg="#F0F4FF" _dark={{ bg: 'rgba(2,14,56,0.9)' }}>
                        <Td
                           colSpan={4}
                           fontWeight="800"
                           fontSize="13px"
                           color="#1E40AF"
                           p="6px 10px"
                           letterSpacing="0.5px"
                           _dark={{ color: '#93C5FD' }}
                           borderColor={borderColor}
                        >
                           TRADING ACCOUNT
                        </Td>
                     </Tr>

                     <HeaderRow />

                     {/* Trading data rows (zipped) */}
                     {zipRows(tradingLeftRows, tradingRightRows, `trading-${companyIndex}`)}

                     {/* Trading subtotals row */}
                     <Tr>
                        <Td {...subtotalTdStyle} width="32%" />
                        <Td {...subtotalTdStyle} width="18%" textAlign="right">
                           {fmt(tradingExpenseSubtotal)}
                        </Td>
                        <Td {...subtotalTdStyle} width="32%" />
                        <Td {...subtotalTdStyle} width="18%" textAlign="right">
                           {fmt(tradingIncomeSubtotal)}
                        </Td>
                     </Tr>

                     {/* Gross Profit / Loss bridge row */}
                     <Tr>
                        {isGrossProfitable ? (
                           // Gross Profit → appears on LEFT (expense) side to balance
                           <>
                              <Td {...bridgeTdStyle(true)} width="32%" textTransform="uppercase">
                                 Gross Profit
                              </Td>
                              <Td {...bridgeTdStyle(true)} width="18%" textAlign="right">
                                 {fmt(grossProfit)}
                              </Td>
                              <Td width="32%" borderColor={borderColor} p="6px 10px" />
                              <Td width="18%" borderColor={borderColor} p="6px 10px" />
                           </>
                        ) : (
                           // Gross Loss → appears on RIGHT (income) side to balance
                           <>
                              <Td width="32%" borderColor={borderColor} p="6px 10px" />
                              <Td width="18%" borderColor={borderColor} p="6px 10px" />
                              <Td {...bridgeTdStyle(false)} width="32%" textTransform="uppercase">
                                 Gross Loss
                              </Td>
                              <Td {...bridgeTdStyle(false)} width="18%" textAlign="right">
                                 {fmt(Math.abs(grossProfit))}
                              </Td>
                           </>
                        )}
                     </Tr>

                     {/* Trading Grand Total row */}
                     <Tr>
                        <Td {...grandTotalTdStyle} width="32%" textTransform="uppercase">Total</Td>
                        <Td {...grandTotalTdStyle} width="18%" textAlign="right">
                           {fmt(tradingLeftTotal)}
                        </Td>
                        <Td {...grandTotalTdStyle} width="32%" textTransform="uppercase">Total</Td>
                        <Td {...grandTotalTdStyle} width="18%" textAlign="right">
                           {fmt(tradingRightTotal)}
                        </Td>
                     </Tr>

                     {/* Spacer */}
                     <Tr><Td colSpan={4} h="16px" bg="transparent" border="none" /></Tr>

                     {/* ════════════════════════════════════════════
                PROFIT & LOSS ACCOUNT SECTION
            ════════════════════════════════════════════ */}
                     <Tr bg="#F0F4FF" _dark={{ bg: 'rgba(2,14,56,0.9)' }}>
                        <Td
                           colSpan={4}
                           fontWeight="800"
                           fontSize="13px"
                           color="#1E40AF"
                           p="6px 10px"
                           letterSpacing="0.5px"
                           _dark={{ color: '#93C5FD' }}
                           borderColor={borderColor}
                        >
                           PROFIT &amp; LOSS ACCOUNT
                        </Td>
                     </Tr>

                     <HeaderRow />

                     {/* P&L data rows (zipped) */}
                     {zipRows(pnlLeftRows, pnlRightRows, `pnl-${companyIndex}`)}

                     {/* P&L subtotals row */}
                     <Tr>
                        <Td {...subtotalTdStyle} width="32%" />
                        <Td {...subtotalTdStyle} width="18%" textAlign="right">
                           {fmt(pnlLeftWithGross)}
                        </Td>
                        <Td {...subtotalTdStyle} width="32%" />
                        <Td {...subtotalTdStyle} width="18%" textAlign="right">
                           {fmt(pnlRightSubtotal)}
                        </Td>
                     </Tr>

                     {/* Net Profit / Loss bridge row */}
                     <Tr>
                        {isNetProfitable ? (
                           // Net Profit → on LEFT side to balance
                           <>
                              <Td {...bridgeTdStyle(true)} width="32%" textTransform="uppercase">
                                 Net Profit
                              </Td>
                              <Td {...bridgeTdStyle(true)} width="18%" textAlign="right">
                                 {fmt(netProfit)}
                              </Td>
                              <Td width="32%" borderColor={borderColor} p="6px 10px" />
                              <Td width="18%" borderColor={borderColor} p="6px 10px" />
                           </>
                        ) : (
                           // Net Loss → on RIGHT side to balance
                           <>
                              <Td width="32%" borderColor={borderColor} p="6px 10px" />
                              <Td width="18%" borderColor={borderColor} p="6px 10px" />
                              <Td {...bridgeTdStyle(false)} width="32%" textTransform="uppercase">
                                 Net Loss
                              </Td>
                              <Td {...bridgeTdStyle(false)} width="18%" textAlign="right">
                                 {fmt(Math.abs(netProfit))}
                              </Td>
                           </>
                        )}
                     </Tr>

                     {/* P&L Grand Total row */}
                     <Tr>
                        <Td {...grandTotalTdStyle} width="32%" textTransform="uppercase">Total</Td>
                        <Td {...grandTotalTdStyle} width="18%" textAlign="right">
                           {fmt(pnlLeftTotal)}
                        </Td>
                        <Td {...grandTotalTdStyle} width="32%" textTransform="uppercase">Total</Td>
                        <Td {...grandTotalTdStyle} width="18%" textAlign="right">
                           {fmt(pnlRightTotal)}
                        </Td>
                     </Tr>

                     {/* Between-company spacer */}
                     <Tr><Td colSpan={4} h="24px" bg="transparent" border="none" /></Tr>

                  </React.Fragment>
               );
            })}
         </>
      );
   };

   const renderReportContent = () => {
      if (isLoading) {
         return (
            <Tr>
               <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                  <Loader />
               </Td>
            </Tr>
         );
      }

      // Safely handle null/undefined ProfitLossMonthly
      if (!ProfitLossMonthly || !Array.isArray(ProfitLossMonthly)) {
         return (
            <Tr>
               <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                  <Text>No data available</Text>
               </Td>
            </Tr>
         );
      }

      // Handle empty array case
      if (ProfitLossMonthly.length === 0) {
         return (
            <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
               <Td
                  p="2px"
                  py="3px"
                  fontSize="10px"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  maxW="150px"
                  overflow="hidden"
                  colSpan={table.getVisibleFlatColumns().length}
                  justifyContent="center"
                  alignItems="center"
                  width="100%">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label>No profit and loss data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      // Format currency values helper function with smaller decimal font size
      const formatCurrencyWithSmallDecimal = (value) => {
         if (value === null || value === undefined) return '-';
         const numValue = Number(value);
         if (isNaN(numValue)) return value;

         const formatted = new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
         }).format(Math.abs(numValue));

         // Split into integer and decimal parts for smaller decimal font
         const parts = formatted.split('.');
         if (parts.length === 2) {
            return (
               <>
                  {parts[0]}.<span style={{ fontSize: '10px' }}>{parts[1]}</span>
               </>
            );
         }
         return formatted;
      };

      // Helper function to combine monthly data for same account names
      const combineMonthlyData = (groups, allMonths) => {
         // Create a map to group accounts across all groups by account name
         const accountMap = new Map();

         groups.forEach((group) => {
            (group?.data || []).forEach((item) => {
               const accountName = item?.accountName || '-';
               const groupType = group?.type || 'Uncategorized';
               const key = `${groupType}-${accountName}`;

               if (accountMap.has(key)) {
                  // Account already exists, combine the monthly data
                  const existing = accountMap.get(key);
                  const combinedMonthData = { ...existing.monthData };

                  // Combine month data by adding values
                  allMonths.forEach((month) => {
                     const existingValue = parseFloat(existing.monthData?.[month] || 0);
                     const newValue = parseFloat(group?.monthData?.[month] || 0);
                     combinedMonthData[month] = (existingValue + newValue).toString();
                  });

                  accountMap.set(key, {
                     ...existing,
                     monthData: combinedMonthData,
                  });
               } else {
                  accountMap.set(key, {
                     accountName,
                     groupType,
                     monthData: group?.monthData || {},
                  });
               }
            });
         });

         // Group back by group type
         const groupedByType = new Map();
         accountMap.forEach((account) => {
            const groupType = account.groupType;
            if (!groupedByType.has(groupType)) {
               groupedByType.set(groupType, []);
            }
            groupedByType.get(groupType).push(account);
         });

         return Array.from(groupedByType.entries()).map(([groupType, accounts]) => ({
            type: groupType,
            data: accounts,
         }));
      };

      // Handle T Format report type
      if (reportType === 'Profit & Loss Vertical') {
         if (!ProfitLossMonthly[0]?.data || !Array.isArray(ProfitLossMonthly[0].data)) {
            return (
               <Tr>
                  <Td colSpan={2} textAlign="center" py="100px">
                     <Text>No data available for vertical format</Text>
                  </Td>
               </Tr>
            );
         }
         return renderVerticalFormatProfitLossMonthly();
      }

      if (reportType === 'Profit & Loss T Format') {
         if (!ProfitLossMonthly[0]?.data || !Array.isArray(ProfitLossMonthly[0].data)) {
            return (
               <Tr>
                  <Td colSpan={4} textAlign="center" py="100px">
                     <Text>No data available for T format</Text>
                  </Td>
               </Tr>
            );
         }
         return renderTFormatProfitLossMonthly();
      }

      if (reportType === 'Profit & Loss Monthly') {
         if (!ProfitLossMonthly[0]?.data || !Array.isArray(ProfitLossMonthly[0].data)) {
            return (
               <Tr>
                  <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                     <Text>No data available for monthly format</Text>
                  </Td>
               </Tr>
            );
         }

         // First collect all unique months from all groups across all companies
         const allMonths = Array.from(
            new Set(
               ProfitLossMonthly.flatMap((company) =>
                  (company?.data || []).flatMap((group) => (group?.monthData ? Object.keys(group.monthData) : [])),
               ),
            ),
         ).sort((a, b) => {
            // Sort months chronologically
            const monthsOrder = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
            const monthA = a.split('-')[0];
            const monthB = b.split('-')[0];
            return monthsOrder.indexOf(monthA) - monthsOrder.indexOf(monthB);
         });

         return (
            <>
               {ProfitLossMonthly.map((company, companyIndex) => {
                  // Group accounts to avoid duplication
                  const groupedData = combineMonthlyData(company?.data || [], allMonths);

                  return (
                     <Box key={`company-${companyIndex}`}>
                        {/* Company Header */}
                        <Text fontSize="xl" fontWeight="bold" bg={companyBg} color={textColor} px={2}>
                           {company?.companyName || 'Unnamed Company'}
                        </Text>

                        {/* Main table containing all data */}
                        <Table variant="simple" size="sm">
                           <Thead>
                              <Tr bg="#F5F5F5" _dark={{ bg: 'rgba(2, 14, 56, 0.8)' }}>
                                 <Th color={textColor} borderColor={borderColor} width="30%">
                                    Account
                                 </Th>
                                 {allMonths.map((month) => (
                                    <Th
                                       key={month}
                                       color={textColor}
                                       borderColor={borderColor}
                                       isNumeric
                                       width={`${70 / allMonths.length}%`}>
                                       {month}
                                    </Th>
                                 ))}
                              </Tr>
                           </Thead>

                           <Tbody>
                              {groupedData.map((group, groupIndex) => (
                                 <React.Fragment key={`group-${groupIndex}`}>
                                    {/* Group Header Row */}
                                    <Tr bg="rgba(0, 63, 140, 0.15)" _dark={{ bg: 'rgba(2, 14, 56, 0.8)' }}>
                                       <Td
                                          colSpan={allMonths.length + 1}
                                          p="4px"
                                          fontSize={'16px'}
                                          fontWeight="bold"
                                          color={textColor}
                                          borderColor={borderColor}>
                                          {group?.type || 'Uncategorized'}
                                       </Td>
                                    </Tr>

                                    {/* Account Rows - Now grouped by account name */}
                                    {(group?.data || []).map((item, itemIndex) => (
                                       <Tr
                                          key={`item-${itemIndex}`}
                                          bg={itemIndex % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                                          _dark={{ bg: itemIndex % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                                          <Td
                                             p="2px"
                                             fontSize={'14px'}
                                             color={textColor}
                                             borderColor={borderColor}
                                             pl="20px">
                                             {item?.accountName || '-'}
                                          </Td>
                                          {allMonths.map((month) => (
                                             <Td
                                                key={month}
                                                p="2px"
                                                fontSize={'14px'}
                                                color={textColor}
                                                borderColor={borderColor}
                                                isNumeric>
                                                {formatCurrencyWithSmallDecimal(
                                                   (item?.monthData && item.monthData[month]) || '0',
                                                )}
                                             </Td>
                                          ))}
                                       </Tr>
                                    ))}
                                 </React.Fragment>
                              ))}
                           </Tbody>
                        </Table>
                     </Box>
                  );
               })}
            </>
         );
      }

      // Default table rendering for other cases
      return (
         <>
            {table.getRowModel().rows.map((row, index) => (
               <Tr
                  key={row.id}
                  bg={index % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                  _dark={{ bg: index % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                  {row.getVisibleCells().map((cell) => (
                     <Td key={cell.id} p="10px" borderColor={borderColor}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                     </Td>
                  ))}
               </Tr>
            ))}
         </>
      );
   };

   return (
      <>
         {/* Title Outside Card */}
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Profit & Loss
               </Text>
            </Flex>
            <Flex></Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex alignItems="center" gap={3} justifyContent={'end'}>
               <div flex="1" mr={''} justifyContent="center">
                  <Box my={2} width="300px" fontSize={'13px'} fontWeight={500} display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width" mt={5}>
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </div>
               <Box flex="1" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
                  <Box my={2} zIndex={3} fontSize={'13px'} fontWeight={500}>
                     <label>Report Type</label>
                     <Select
                        options={reportTypeOptions}
                        value={reportTypeOptions.find((option) => option.value === reportType)}
                        onChange={(selectedOption) => {
                           setReportType(selectedOption.value);
                           setExpandedItems({});
                        }}
                        placeholder="Select Report Type"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
                  {reportType !== 'Profit & Loss Monthly' && (
                     <Box my={2} ml={2} zIndex={3} fontSize={'13px'} fontWeight={500} width={"15%"}>
                        <label>Stock Balance</label>
                        <Input
                           value={stockInput || ''}
                           onChange={(e) => setStockInput(e.target.value)}
                           placeholder="Enter Stock"
                           size="sm"
                           bg={controlBg}
                           borderColor={controlBorder}
                           _hover={{
                              borderColor: controlBorderHover,
                           }}
                           _focus={{
                              boxShadow: focusBoxShadow,
                              borderColor: controlBorderHover,
                           }}
                           color={textColor}
                           _placeholder={{
                              color: placeholderColor,
                           }}
                           height="30px"
                        />
                     </Box>
                  )}
               </Box>
               <Flex>
                  <Box flex="1" mr={3}>
                     <MotionFlex
                        ref={wrapperRef}
                        align="center"
                        bg={bg}
                        borderRadius="full"
                        cursor="pointer"
                        px={expanded ? 3 : 0}
                        w={expanded ? '250px' : '40px'}
                        h="40px"
                        transition="all 0.3s ease"
                        onClick={() => setExpanded(true)}>
                        <MotionSearchIcon
                           color={icon}
                           animate={{ rotate: expanded ? 0 : 90 }}
                           transition={{ duration: 0.3 }}
                           style={{
                              marginRight: expanded ? '8px' : '10px',
                              marginLeft: expanded ? '0' : '10px',
                           }}
                        />
                        {expanded && (
                           <Input
                              variant="unstyled"
                              placeholder="Search accounts..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                              color={icon}
                              flex="1"
                           />
                        )}
                     </MotionFlex>
                  </Box>
                  <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
                     <LuRefreshCcw size={20} mr={2} />
                  </Button>

                  <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                     <IoFilterOutline size={22} />
                  </Button>

                  <Flex alignItems="center">
                     <Flex mr={2}></Flex>
                     <Flex mr={2}>
                        <Popover>
                           <PopoverTrigger>
                              <IconButton
                                 icon={<Image src={Download} boxSize="24px" />}
                                 aria-label="Download Options"
                              />
                           </PopoverTrigger>
                           <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                              <PopoverBody p="3">
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadExcel}
                                    justifyContent="space-between"
                                    mb={3}>
                                    <img src={xls} alt="Download XLS" width="30px" />
                                    Download Excel
                                 </Button>
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadPDF}
                                    justifyContent="space-between">
                                    <img src={xls} alt="Download PDF" width="30px" />
                                    Download PDF
                                 </Button>
                              </PopoverBody>
                           </PopoverContent>
                        </Popover>
                     </Flex>
                  </Flex>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                        <Box my={2} fontSize={'13px'} fontWeight={500}>
                           <label>Report Type</label>
                           <Select
                              options={reportTypeOptions}
                              value={reportTypeOptions.find((option) => option.value === reportType)}
                              onChange={(selectedOption) => {
                                 setReportType(selectedOption.value);
                                 setExpandedItems({});
                              }}
                              placeholder="Select Report Type"
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>

                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '60vh', md: '65vh', xl: '70vh' }}
                  maxH={{ base: '60vh', md: '65vh', xl: '70vh' }}>
                  {isFilterLoading && (
                     <Box
                        position="fixed"
                        top={0} left={0} right={0} bottom={0}
                        zIndex={9999}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg={isDark ? 'rgba(10,20,50,0.60)' : 'rgba(255,255,255,0.60)'}
                        backdropFilter="blur(3px)"
                     >
                        <Flex direction="column" align="center" gap={3}>
                           <Loader />
                        </Flex>
                     </Box>
                  )}
                  {reportType === 'Profit & Loss Vertical' ? (
                     <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                        <Thead>
                           <Tr
                              bg={'#F5F5F5'}
                              position="sticky"
                              top="-1"
                              zIndex="1"
                              color={textColor}
                              borderTop="1px solid"
                              borderBottom="1px solid"
                              borderColor={borderColor}>
                              <Th
                                 cursor="pointer"
                                 p="2px"
                                 py="4px"
                                 _dark={{ bg: '#080238' }}
                                 fontWeight="600"
                                 whiteSpace="nowrap">
                                 <Text fontSize={{ sm: '10px', lg: '12px' }} color={textColor}>
                                    Account
                                 </Text>
                              </Th>
                              <Th
                                 cursor="pointer"
                                 p="2px"
                                 py="4px"
                                 _dark={{ bg: '#080238' }}
                                 fontWeight="600"
                                 whiteSpace="nowrap"
                                 isNumeric>
                                 <Text fontSize={{ sm: '10px', lg: '12px' }} color={textColor}>
                                    Amount
                                 </Text>
                              </Th>
                           </Tr>
                        </Thead>
                        <Tbody>{renderReportContent()}</Tbody>
                     </Table>
                  ) : (
                     <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                        <Thead>
                           {table.getHeaderGroups().map((headerGroup) => (
                              <Tr key={headerGroup.id}>
                                 {headerGroup.headers.map((header) => {
                                    if (!header.column.getIsVisible()) return null;

                                    const columnId = header.column.id;
                                    const isNumericColumn = ['debit', 'credit'].includes(columnId);

                                    return (
                                       <Th
                                          borderTop="1px solid"
                                          key={header.id}
                                          colSpan={header.colSpan}
                                          borderColor={borderColor}
                                          cursor="pointer"
                                          p="2px"
                                          py="4px"
                                          fontSize="10px"
                                          _dark={{ bg: '#080238' }}
                                          fontWeight="600"
                                          bg={'#F5F5F5'}
                                          position="sticky"
                                          top="-1"
                                          zIndex="1"
                                          color={textColor}
                                          isNumeric={isNumericColumn}
                                          whiteSpace="nowrap"
                                          onClick={header.column.getToggleSortingHandler()}>
                                          <Flex
                                             justifyContent={isNumericColumn ? 'flex-end' : 'space-between'}
                                             align="center"
                                             fontSize={{ sm: '10px', lg: '12px' }}
                                             color={textColor}>
                                             {flexRender(header.column.columnDef.header, header.getContext())}
                                             {{
                                                asc: '↑',
                                                desc: '↓',
                                             }[header.column.getIsSorted()] ?? null}
                                          </Flex>
                                       </Th>
                                    );
                                 })}
                              </Tr>
                           ))}
                        </Thead>
                        <Tbody>{renderReportContent()}</Tbody>
                     </Table>
                  )}
               </Box>
            </Card>
         </Grid >

         {/* Column Visibility Modal */}
         < ColumnVisibilityModal />

         <AccountingReportsFilter
            type={reportType}
            // osType={osType}
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={datePartyWiseSalesRange.fromDate}
            toDate={datePartyWiseSalesRange.toDate}
            entityType="profitLoss"
            onApply={() => setIsFilterLoading(true)}
         />
      </>
   );
};

export default ProfitLossMonthly;
